import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const detailControllerRestUrl = detailServicesPath + '/customers/orders/'
const organizationDetailControllerRestUrl = detailServicesPath + '/organization/orders/'

const getDetailOrdersRestUrl = (organization = false) =>
    organization ? organizationDetailControllerRestUrl : detailControllerRestUrl

export default class DetailControllerService {

    static async getAll(orderId, requestsCuttingId) {
        return axios.get(`${detailControllerRestUrl}${orderId}/details?requestsCuttingId=${requestsCuttingId}`);
    }

    static async getById(orderId, id) {
        return axios.get(`${detailControllerRestUrl}${orderId}/details/${id}`);
    }

    static async save(orderId, requestsCuttingId, data) {
        return await axios.post(`${detailControllerRestUrl}${orderId}/details?requestsCuttingId=${requestsCuttingId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(orderId, data) {
        await axios.delete(`${detailControllerRestUrl}${data.orderId}/details/${data.id}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async update(orderId, id, data, {organization = false} = {}) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.put(`${getDetailOrdersRestUrl(organization)}${orderId}/details/${id}${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async resetContour(orderId, id) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.patch(`${detailControllerRestUrl}${orderId}/details/${id}/reset-contour${params}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllByOrderId(orderId) {
        return axios.get(`${detailControllerRestUrl}${orderId}/details`);
    }


    static async exportFile(orderId, id, machineManufacturer) {
        return axios.get(`${detailControllerRestUrl}${orderId}/details/${id}/file?machineManufacturer=${machineManufacturer}`);
    }

    static async saveBySample(orderId, requestsCuttingId, data) {
        return await axios.post(`${detailControllerRestUrl}${orderId}/details/by-sample?requestsCuttingId=${requestsCuttingId}`,
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

}
